
import React from 'react';
const AssetMiniDetail = ({ assetDetail }) => {
    if (!assetDetail || assetDetail.length === 0) return null;

    return (
        <div className="mt-3">
            {assetDetail.map((asset, index) => {
                const assetData = asset.data || asset;
                return (
                    <div key={index} className=" mb-3">
                        <label className='pt-1'><span className='alert-text'>Asset Name :</span> {assetData.asset_name ?? "-"}</label> <br />
                        <label className='pt-1'><span className='alert-text'>Asset Code :</span> {assetData.asset_nickname ?? "-"}</label> <br />
                        <label className='pt-1'><span className='alert-text'>Asset Type :</span> {assetData.asset_type.asset_type_name ?? "-"}</label> <br />
                        <label className='pt-1'><span className='alert-text'>Asset Matrix : </span>{assetData.asset_matrix?.asset_matrix_unique_id ?? "-"}</label> <br />
                        <label className='pt-1'><span className='alert-text'>Manufacturer: </span>{assetData.manufacturer?.manufacturer ?? "-"} </label><br />
                    </div>
                );
            })}
        </div>
    );
};

export default AssetMiniDetail;